import { render, staticRenderFns } from "./logistics-pane.vue?vue&type=template&id=429cb161&scoped=true"
import script from "./logistics-pane.vue?vue&type=script&lang=js"
export * from "./logistics-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429cb161",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('429cb161')) {
      api.createRecord('429cb161', component.options)
    } else {
      api.reload('429cb161', component.options)
    }
    module.hot.accept("./logistics-pane.vue?vue&type=template&id=429cb161&scoped=true", function () {
      api.rerender('429cb161', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/ssr-manage/logistics-pane.vue"
export default component.exports